<template>
    <div
        class="cert-page relative p-8 lg:p-16 text-gray-700"
        :style="{
            backgroundImage: `url(${certContent?.backgroundImage})`,
            color: certContent?.textColor,
        }"
    >
        <img v-if="player?.logo" class="h-8 sm:h-10" :src="player.logo" />
        <div class="pt-12 sm:pt-24 pb-4 text-center">
            <h3 class="font-bold text-xl lg:text-3xl uppercase opacity-60">
                {{ $t("r_player.certificate.title") }}
            </h3>
            <div class="mt-4 mx-auto w-9 h-[3px] ct-bg-4 rounded-sm"></div>
            <div
                v-if="certContent?.courseImage"
                class="h-20 sm:h-40 w-20 sm:w-40 mx-auto mt-12 bg-white shadow-xl rounded-2xl overflow-hidden"
            >
                <img :src="certContent?.courseImage" alt="cert" />
            </div>
            <p class="mt-12 sm:mt-24 text-3xl lg:text-5xl font-bold">
                {{ issuedCert?.userName }}
            </p>
            <div class="mt-4 mx-auto w-9 h-[3px] ct-bg-4 rounded-sm"></div>
            <p class="mt-12 sm:mt-24 text-2xl lg:text-4xl font-bold">
                {{ certContent?.courseName }}
            </p>
            <div class="mt-12 text-base lg:text-xl font-bold opacity-60 max-w-lg mx-auto">
                <MarkdownHtml :markdown="certContent?.courseDescription" />
            </div>

            <p class="mt-12 text-base lg:text-xl font-bold uppercase">
                {{ formattedDate }}
            </p>
        </div>
        <div class="mt-12 sm:mt-24 flex justify-between">
            <img
                class="hidden sm:block h-10 lg:h-16"
                src="@/views/tools/player/assets/blockchain.svg"
            />
            <span class="text-sm sm:text-base font-bold opacity-50">
                ID: {{ issuedCert?.uuid }}
            </span>
        </div>
    </div>
</template>

<script>
import { i18n } from "@/i18n";
import moment from "moment";
import { hexToRgba } from "@/shared/utils/helpers";
import { MarkdownHtml } from "@easy/ui/text";

export default {
    props: {
        certContent: {
            type: Object,
            default: () => ({}),
        },
        issuedCert: {
            type: Object,
            required: true,
        },
        player: {
            type: Object,
            required: true,
        },
    },
    components: {
        MarkdownHtml,
    },
    computed: {
        formattedDate() {
            return this.issuedCert?.createdAt
                ? moment(this.issuedCert?.createdAt)
                      .locale(i18n.global.locale.value)
                      .format("MMMM YYYY")
                : "";
        },
    },
    methods: {
        hexToRgba,
    },
};
</script>

<style lang="scss">
.cert-page {
    background: url("@/views/tools/player/assets/certs-back.png");
    background-size: cover;
}
</style>
